export default function PHP_filter_input_array() {
  return (
    <div>
      <h1>PHP_filter_input_array</h1>
    </div>
  );
}
